"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
const wp_query_params = {
  per_page: 4
};
const wp_query = new WP_Query(wp_query_params);
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <Skeleton className="aspect-[4/5] w-full rounded-2xl" />
            <div className="flex flex-col items-center gap-2 px-4">
              <Skeleton className="h-6 w-3/4" />
              <Skeleton className="h-5 w-1/4" />
              <Skeleton className="mt-4 h-10 w-full rounded-lg" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Unable to load the signature collection at this time.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Our signature collection is currently being updated.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group flex flex-col overflow-hidden rounded-2xl bg-card/80 shadow-sm backdrop-blur-sm transition-all duration-500 hover:shadow-md">
          <Link to={product.link} className="block aspect-[4/5] overflow-hidden bg-muted/30">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
                No Image Available
              </div>}
          </Link>
          
          <div className="flex flex-grow flex-col items-center p-6 text-center">
            <Link to={product.link} className="mb-2 block">
              <h3 className="line-clamp-2 font-serif text-xl font-medium text-foreground transition-colors hover:text-primary">
                {product.title}
              </h3>
            </Link>
            
            <p className="mb-6 font-medium text-primary">
              ${product.price?.toFixed(2)}
            </p>
            
            <div className="mt-auto w-full">
              <AddToCartButton productId={product.id} className="w-full" buttonClassName="w-full rounded-full bg-primary text-primary-foreground transition-colors hover:bg-primary/90" text="Shop Now" showQuantity={false} />
            </div>
          </div>
        </div>)}
    </div>;
}
export default function ShopHighlights() {
  return <section id="shophighlights" className="bg-background px-6 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="mb-6 font-serif text-4xl font-medium tracking-tight text-foreground md:text-5xl">
            Signature Collection
          </h2>
          <Separator className="mx-auto h-[2px] w-16 bg-primary" />
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 4
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}